import { Copy } from "assets/Icon";
import { IconButton, useTheme } from "@mui/material";
import useNotify from "hooks/useNotify";

function CopyToClipboard({ value }) {
  const theme = useTheme();
  const notify = useNotify();

  const copyToClipAdd = (value) => {
    navigator.clipboard.writeText(value);

    notify("کد با موفقیت کپی شد", "success");
  };

  return (
    <IconButton
      aria-label="copy"
      onClick={() => {
        copyToClipAdd(value);
      }}
    >
      <Copy color={theme.palette.secondary.main} />
    </IconButton>
  );
}

export default CopyToClipboard;
